import CrudPage from "@/components/CrudPage";
import { Pill } from "@/components/kit";
import { fmtD, todayISO, addDaysISO } from "@/lib/api";
import { Photos } from "@/components/PhotoPicker";

const KINDS = [["pest_control", "Pest control"], ["maintenance", "Maintenance / repair"], ["gas_safety", "Gas safety"], ["electrical", "Electrical (PAT / EICR)"], ["extraction_cleaning", "Extraction / duct cleaning"], ["fire_safety", "Fire safety"], ["other", "Other"]].map(([value, label]) => ({ value, label }));
const kindLabel = (k) => KINDS.find((x) => x.value === k)?.label || k;

export default function Contractors() {
  const today = todayISO();
  const soon = addDaysISO(today, 7);
  const due = (r) => (!r.next_due ? null : r.next_due < today ? "overdue" : r.next_due <= soon ? "exception" : "ok");
  return (
    <CrudPage eyebrow="Register" title="Pest control & maintenance" resource="contractor_visits" venueScoped
      subtitle="Every contractor visit with what they found and fixed. You'll get an alert a week before the next visit is due."
      defaults={{ kind: "pest_control", contractor: "", visit_date: today, result: "no_issues", findings: "", action_taken: "", next_due: "", report_ref: "", photo_ids: [] }}
      columns={[
        { key: "visit_date", label: "Visit", render: (r) => <div><div className="font-semibold text-slate-900">{fmtD(r.visit_date)}</div><div className="text-xs text-slate-500">{kindLabel(r.kind)}</div></div> },
        { key: "contractor", label: "Contractor" },
        { key: "result", label: "Result", render: (r) => <div><Pill status={r.result === "no_issues" ? "ok" : "overdue"} label={r.result === "no_issues" ? "No issues" : "Issues found"} />{r.findings && <div className="mt-1 max-w-xs text-xs text-slate-500">{r.findings}</div>}</div> },
        { key: "next_due", label: "Next due", render: (r) => (r.next_due ? <Pill status={due(r)} label={fmtD(r.next_due)} /> : "—") },
        { key: "photo_ids", label: "Report", render: (r) => <div><span className="text-xs text-slate-500">{r.report_ref || (r.photo_ids?.length ? "" : "—")}</span>{!!r.photo_ids?.length && <div className="mt-1"><Photos ids={r.photo_ids} size="h-10 w-10" /></div>}</div> },
      ]}
      fields={[
        { key: "kind", label: "Type of visit", type: "select", options: KINDS },
        { key: "contractor", label: "Contractor", required: true, placeholder: "e.g. Rentokil" },
        { key: "visit_date", label: "Visit date", type: "date", required: true },
        { key: "result", label: "Result", type: "select", options: [{ value: "no_issues", label: "No issues" }, { value: "issues_found", label: "Issues found" }] },
        { key: "findings", label: "What they found", type: "textarea" },
        { key: "action_taken", label: "What was done about it", type: "textarea" },
        { key: "next_due", label: "Next visit due", type: "date" },
        { key: "report_ref", label: "Report / job number" },
        { key: "photo_ids", label: "Photos of the report or work", type: "photos" },
      ]}
    />
  );
}
